export default {"src":"/_next/static/media/hamburger.eb149d3f.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};